<template>
    <header class="page-header bg-azul">
        <div class="content-header">
            <div>
                <button type="button" class="btn btn-danger mr-1 text-white" data-toggle="layout"
                        @click="click"
                        data-action="sidebar_toggle">
                    <i class="fas fa-stream fa-flip-horizontal"></i>
                </button>
            </div>
        </div>
        <div></div>
    </header>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'

    export default {
        name: "Header",
        model: {
            prop: 'menu',
            event: 'open'
        },
        props: {
            menu: Boolean
        },

        methods: {

            ...mapMutations([
                'SET_MENU',
            ]),

            click: function () {
                this.SET_MENU(!this.menu);
                this.$emit('open', !this.menu);
            }
        }
    }
</script>

<style scoped lang="scss">

    @import "../style/base";

    .page-header {
        position: sticky;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1030;
        min-width: 320px;
        max-width: 100%;
        width: auto;
        margin: 0 auto;
        box-shadow: 0 3px 3px $sekaiGray;

        & .content-header {
            padding-left: 1.75rem;
            padding-right: 1.75rem;
            @include flexRow;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
            height: 4.375rem;
        }
    }


</style>